<template>
  <div class="knowledge-base-shell" :class="{ embedded }">
    <KnowledgeWorkspace :ck="ck" :creation-preset="creationPreset" :creation-preset-key="creationPresetKey" @close="$emit('close')" @notify="notify" />
  </div>
</template>

<script>
import KnowledgeWorkspace from './KnowledgeWorkspace.vue';

export default {
  name: 'KnowledgeBasePanel',
  components: { KnowledgeWorkspace },
  props: {
    ck: { type: String, default: '' },
    isOpen: { type: Boolean, default: false },
    embedded: { type: Boolean, default: false },
    creationPreset: { type: Object, default: null },
    creationPresetKey: { type: Number, default: 0 }
  },
  methods: {
    notify(message) { this.$emit('notify', message); }
  }
};
</script>

<style scoped>
.knowledge-base-shell{height:100%;width:100%;min-height:0;background:var(--bg-card,#fff)}
.knowledge-base-shell:not(.embedded){position:fixed;inset:0;z-index:1000}
</style>
